import { Box, Typography, useTheme } from "@mui/material";
import { FC } from "react";

type Props = {
	title: string;
	subtitle?: string;
	bannerImage: string;
	insetImage?: string;
	height: number | string;
	horizontalAdjust?: number | string;
	verticalAdjust?: number | string;
	brightnessAdjust?: number;
};

const ScreenBanner: FC<Props> = ({ title, subtitle, bannerImage, insetImage, height, horizontalAdjust, verticalAdjust, brightnessAdjust }) => {
	const theme = useTheme();

	return (
		<Box sx={{ position: 'relative' }}>
			<Box
				component="img"
				src={bannerImage}
				alt={title}
				sx={{
					width: '100%',
					height: height,
					borderBottom: `2px solid ${theme.palette.divider}`,
					objectFit: 'cover',
					objectPosition: `${horizontalAdjust || 0} ${verticalAdjust || 0}`,
					borderRadius: '12px 12px 0 0',
					filter: `brightness(${brightnessAdjust || 1})`
				}}
			/>
			<Box
				sx={{
					position: 'absolute',
					left: 32,
					bottom: 24
				}}
			>
				<Typography variant="h4" sx={{ color: theme.palette.common.white }}>{title}</Typography>
				{subtitle && (
					<Typography variant="h6" sx={{ color: theme.palette.grey[300] }}>{subtitle}</Typography>
				)}
			</Box>
			{insetImage && (
				<Box
					component="img"
					src={insetImage}
					alt={title}
					sx={{
						position: 'absolute',
						bottom: { xs: -32, sm: -32, md: -32, lg: -48, xl: -80 },
						right: { xs: 16, sm: 32, md: 48, lg: 48, xl: 64 },
						width: { xs: 90, sm: 110, md: 130, lg: 160, xl: 160 },
						height: { xs: 90, sm: 110, md: 130, lg: 160, xl: 160 },
						objectFit: 'cover',
						borderRadius: '50%',
						border: `2px solid ${theme.palette.divider}`,
					}}
				/>
			)}
		</Box>
	);
};

export default ScreenBanner;
